import dayjs from "dayjs";

const calculateDateDiff = (
  arriving: string,
  leaving: string,
  unit: string = "days"
) => dayjs(leaving).diff(arriving, unit);

export default calculateDateDiff;
